import React, { forwardRef, ReactElement, useEffect, useState } from 'react';
import Button from '@/components/Button';
import CurrencySelectBox, { CurrencyItem } from '@/components/CurrencySelectBox';
import { currencyCodes as supportedCurrencies } from '@/config';

export interface CurrencyFormData {
  value?: string;
}

interface CurrencyFormProps {
  value?: string;
  onSubmit: (formData: CurrencyFormData) => Promise<void>;
  loading?: boolean;
  onChangeLoading?: (loading: boolean) => void;
  hideLabel?: true;
  description?: string | ReactElement;
}

const CurrencyForm = forwardRef<HTMLFormElement, CurrencyFormProps>(function CurrencyForm(
  { value, onSubmit, loading: loadingProp, onChangeLoading, hideLabel, description },
  ref,
) {
  const [formData, setFormData] = useState<CurrencyFormData>({ value: value });

  const handleCurrencySelect = (language?: CurrencyItem | null) => {
    setFormData({ value: language?.id });
  };

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(loadingProp || false);
  }, [loadingProp]);

  useEffect(() => {
    if (onChangeLoading) {
      onChangeLoading(loading);
    }
  }, [loading, onChangeLoading]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setLoading(true);
    console.log('submit');
    await onSubmit(formData);
    setLoading(false);
  };

  return (
    <form ref={ref} onSubmit={handleSubmit}>
      <div className="grid grid-cols-2 gap-4 lg:gap-8">
        <div className="col-span-2">
          <div className="pb-2">
            <CurrencySelectBox
              value={formData.value || ''}
              onSelect={handleCurrencySelect}
              currencyCodes={supportedCurrencies}
              hideLabel={hideLabel}
            />
            {description && typeof description !== 'string' ? (
              description
            ) : (
              <span className="block mb-1">{description}</span>
            )}
          </div>
        </div>
      </div>
      <div className="mt-4 flex justify-end">
        <Button type="submit" variant="primary" loading={loading}>
          Save
        </Button>
      </div>
    </form>
  );
});

export default CurrencyForm;
